import { render, staticRenderFns } from "./SamsaraTile.vue?vue&type=template&id=e2e97762&"
import script from "./SamsaraTile.vue?vue&type=script&lang=js&"
export * from "./SamsaraTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports